import React from "react";
import { EuiFormRow, EuiFieldText } from "@elastic/eui";
import _ from "lodash";

function AbstractString({ options, errors, entityObject, register }) {
    return (
        <EuiFormRow
            label={options.label}
            key={options.name}
            fullWidth
            helpText={options.helpText}
            isInvalid={!_.isNil(errors) && !_.isNil(errors[options.name])}
            defaultValue={entityObject && entityObject[options.name]}
            error={options.errorMessage}
        >
            <EuiFieldText
                fullWidth
                name={options.name}
                placeholder={options.placeholder}
                defaultValue={entityObject && entityObject[options.name]}
                autoComplete="off"
                inputRef={
                    register &&
                    register({
                        ...options.validation,
                    })
                }
            />
        </EuiFormRow>
    );
}

export default AbstractString;
